import api from '../../api/index'

const vrLoungeApiService = {
  async fetchVrLounge (vrloungeId) {
    const urlEnd = `/v2/vrlounges/${vrloungeId}`
    const method = 'get'
    const response = await api.asyncRequest(urlEnd, method)
    return response.ok ? response.data : null
  }
}

export default vrLoungeApiService
